import styled from 'styled-components'

import { maxDevice } from '../../../App/Util'

export const GraphContainer = styled.div`
  align-self: center;
  width: 400px;
  max-width: 400px;
  @media ${maxDevice.laptop} {
    width: 80%;
  }
`
